import theme, {themeColors} from '../../../../theme/Theme';

export const planFormClasses = {
  shadows: {boxShadow: theme.shadows[2]},
  valid: {backgroundColor: '#c4e0b4'},
  invalid: {backgroundColor: '#ff9496'},
  partial: {backgroundColor: themeColors.lightWarning},
  na: {backgroundColor: '#ccc'},
  validationIcon: {
    marginLeft: 'auto',
    marginTop: 'auto',
    marginBottom: 'auto',
    width: 'auto !important',
  },
  nothing: {
    backgroundColor: '#ffffff',
  },
} as const;

export type PlanFormClassKey = keyof typeof planFormClasses;
